document.addEventListener('DOMContentLoaded', function() {
    // Define the hover intent delays
    const showDelay = 200;
    const hideDelay = 500;
    let enterTimer, leaveTimer;

    // Check if the device is touch-enabled (for mobile devices)
    const isTouchDevice = 'ontouchstart' in document.documentElement;

    // Get all language switcher elements
    document.querySelectorAll('.wp-block-knightowl-blocks-lang-switcher').forEach(function(switcher) {
        const toggle = switcher.querySelector('.lang-switcher-icon');
        const dropdown = switcher.querySelector('.lang-switcher-dropdown');
        let isDropdownOpen = false;  // Keep track of dropdown state

        // Function to show the dropdown
        const showDropdown = () => {
            clearTimeout(leaveTimer);
            enterTimer = setTimeout(() => {
                dropdown.classList.remove('hide');
                dropdown.setAttribute('aria-hidden', 'false');
                toggle.setAttribute('aria-expanded', 'true');
                isDropdownOpen = true;
            }, showDelay);
        };

        // Function to hide the dropdown
        const hideDropdown = () => {
            clearTimeout(enterTimer);
            leaveTimer = setTimeout(() => {
                dropdown.classList.add('hide');
                dropdown.setAttribute('aria-hidden', 'true');
                toggle.setAttribute('aria-expanded', 'false');
                isDropdownOpen = false;
            }, hideDelay);
        };

        // Handle hover events for desktop (non-touch devices)
        if (!isTouchDevice) {
            switcher.addEventListener('mouseenter', showDropdown);
            switcher.addEventListener('mouseleave', hideDropdown);
        }

        // Handle click/touch for mobile
        toggle.addEventListener('click', function(e) {
            e.preventDefault();
            if (!isDropdownOpen) {
                showDropdown();
            } else {
                hideDropdown();
            }
        });

        // Keyboard events for accessibility
        toggle.addEventListener('keydown', function(e) {
            if (e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();
                if (!isDropdownOpen) {
                    showDropdown();
                } else {
                    hideDropdown();
                }
            }
        });

        // Close dropdown on Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                hideDropdown();
                toggle.focus(); // Focus on the toggle element
            }
        });

        // Click outside to close dropdown
        document.addEventListener('click', function(e) {
            if (!switcher.contains(e.target) && isDropdownOpen) {
                hideDropdown();
            }
        });

        // Reset dropdown state for mobile after close
        if (isTouchDevice) {
            document.addEventListener('touchstart', function(e) {
                if (!switcher.contains(e.target) && isDropdownOpen) {
                    hideDropdown();
                }
            });
        }
    });
});
